<div #container [id]="hotId"></div>